import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PageQuerySchema } from '../pagination';
import { PlanRowSchema } from './shapes';

export const listReleasePlans = defineEndpoint({
  method: 'GET',
  path: '/v1/release-plans',
  params: z.object({}),
  query: PageQuerySchema.pick({ limit: true, cursor: true }),
  body: z.undefined(),
  response: z.object({
    data: z.array(PlanRowSchema),
    meta: z.object({
      nextCursor: z.string().nullable(),
      hasMore: z.boolean(),
      limit: z.number().int(),
    }),
  }),
});
